module.exports = __webpack_public_path__ + "img/background.1fbd90d.jpeg";